import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { UserType, PermissionType } from '@enums';
import { Subscription } from 'rxjs';
import { MeteringPoint } from '@model';
import { SubSink } from 'subsink';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    standalone: false
})
export class SidebarComponent implements OnInit, OnDestroy {
  @Input()
  isHandset: boolean;
  @Input()
  meteringPoints: { meteringPoints: MeteringPoint[]; loaded: boolean };

  @Output()
  toggleEvent = new EventEmitter<boolean>();

  appRouter: Router;
  UserTypeEnum = UserType;
  PermissionEnum = PermissionType;
  navSubsciption: Subscription;

  private subs = new SubSink();

  constructor(private router: Router) {
    this.appRouter = router;

    this.subs.sink = router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        if (this.isHandset) {
          this.toggleEvent.emit(true);
        }
      });
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
